import { Component, OnDestroy, OnInit, ViewEncapsulation, ChangeDetectorRef, HostListener, inject } from '@angular/core';

import { RouterOutlet } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { OpenMobileAppComponent } from '@components/open-mobile-app/open-mobile-app.component';
import { LoaderComponent } from '@components/layouts/loader/loader.component';
import { AppService } from '@services/app.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kzn-root',
  standalone: true,
  imports: [RouterOutlet, LoaderComponent],
  templateUrl: './root.component.html',
  styleUrl: './root.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class RootComponent implements OnInit, OnDestroy {
  private _pageLoaderSubscription!: Subscription;
  private _cdr = inject(ChangeDetectorRef);
  title = 'kaizen';
  isAndroid: boolean = false;
  isiOS: boolean = false;
  pageLoaderDetails = {
    show: false,
    message: '',
  }

  constructor(private dialog: MatDialog, private _appService: AppService) { }

  ngOnInit(): void {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    this.isAndroid = /android/i.test(userAgent);
    this.isiOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;

    this._loadApp();
    const suppressPrompt = sessionStorage.getItem('skipOpenAppPrompt') === '1';
    if ((this.isAndroid || this.isiOS) && !suppressPrompt) {
      this.openMobileAppDialog();
    }
  }

  public openMobileAppDialog() {
    const dialogRef = this.dialog.open(OpenMobileAppComponent, {
      data: {
        isAndroid: this.isAndroid,
        isiOS: this.isiOS,
      },
    });
    dialogRef.afterClosed().subscribe(() => {});
  }

  private _loadApp(){
    this._pageLoaderSubscription = this._appService.pageLoader$.subscribe(details => {
      this.pageLoaderDetails = details;
      this._cdr.detectChanges();
    });
  }

  ngOnDestroy(): void {
    this._pageLoaderSubscription?.unsubscribe();
  }

  // @HostListener('document:contextmenu', ['$event'])
  // onContextMenu(event: MouseEvent): void {
  //   event.preventDefault();
  // }

  // @HostListener('document:keydown', ['$event'])
  // onKeyDown(event: KeyboardEvent): void {
  //   const key = event.key.toLowerCase();
  //   const isCtrlOrCmd = event.ctrlKey || event.metaKey;
  //   const isDevToolsShortcut =
  //     key === 'f12' ||
  //     (isCtrlOrCmd && event.shiftKey && (key === 'i' || key === 'j' || key === 'c')) ||
  //     (isCtrlOrCmd && key === 'u');

  //   if (isDevToolsShortcut) {
  //     event.preventDefault();
  //     event.stopPropagation();
  //   }
  // }
}


